import { DetailsMatch } from '@40seas/entities/business-verification';
import { EnumColor } from '@40seas/frontend/common/providers';

export const detailsMatchColorMapping = {
    [DetailsMatch.PartialMatch]: 'default',
    [DetailsMatch.ExactMatch]: 'success',
    [DetailsMatch.NoMatch]: 'error',
} as { [key in DetailsMatch]: EnumColor };
